import GuildLogoSrc from "../assets/images/guild_logo.png";
import NAFLogoSrc from "../assets/images/naf_reverse_logo.png";

export const LENDERS = [
  {
    apiName: "Guild",
    displayName: "Guild Mortgage",
    url: null,
    adCopy: "Next Step: We need to speak with you! Please call (855)-517-0091",
    logoSrc: GuildLogoSrc,
    nmls: "NMLS ID 3274",
  },
  {
    apiName: "New American Funding",
    displayName: "New American Funding (NAF)",
    url: null,
    adCopy: (
      <>
        We appreciate the opportunity to assist you. A licensed Loan Officer from New American Funding (NAF) will be reaching out shortly to discuss your goals and answer any questions you may have about the program.
        <br /><br />
        In the meantime, if you have additional questions, please feel free to email us at{" "}
        <a href="mailto:reverse@nafinc.com">reverse@nafinc.com</a>, and we'll be happy to help.
        <br /><br />
        Thank you again for connecting with us. We look forward to speaking with you soon!
      </>
    ),
    logoSrc: NAFLogoSrc,
    nmls: "NMLS ID #6606",
    layout: { logoPosition: "above", align: "left" },
  },
];

export function getLenderByBuyer(buyerName) {
  if (!buyerName) return null;
  return LENDERS.find((l) => l.apiName === buyerName) || {
    apiName: buyerName,
    displayName: buyerName,
    url: null,
    adCopy: `You've been matched with ${buyerName}!`,
    logoSrc: null,
    nmls: null,
  };
}
